'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'tire';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f631';
var svgPathData = ['M113.8 278.6c2.6 16.2 7.8 31.5 15.3 45.5l46-15c12.9 20.2 33.1 35.2 56.9 41.3l0 47.5c7.8 1.3 15.8 2 24 2s16.2-.7 24-2l0-47.5c23.8-6.1 44.1-21.2 57-41.3l46 15c7.5-13.9 12.8-29.3 15.3-45.5l-46.4-15.1c.1-2 .2-4 .2-6 0-23.2-8.2-44.4-21.9-61L359.6 156c-11.1-11.5-24.2-21.2-38.6-28.5l-29.6 40.8c-10.9-4.3-22.9-6.7-35.4-6.7s-24.4 2.4-35.4 6.7L191 127.4c-14.4 7.3-27.5 17-38.6 28.5l29.4 40.6c-13.7 16.6-21.9 37.8-21.9 61 0 2 .1 4 .2 6l-46.4 15.1zM288 257.5a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z', 'M256 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 400a256 256 0 1 0 0-512 256 256 0 1 0 0 512z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTire = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;